/* eslint-disable arrow-body-style */
import {Rating} from '@mui/material';
import React, {useEffect, useState} from 'react';

const RatingComponent = (props: any) => {
  const [value, setValue] = useState(0);
  const [editMode, setEditMode] = useState(false);
  useEffect(() => {
    if (props?.value > -1) setValue(Number(props?.value) ?? 0);
  }, [props?.value]);
  useEffect(() => {
    if (props?.cellMode === 'edit') setEditMode(true);
  }, [props?.cellMode]);

  return (
    <Rating
      name="simple-controlled"
      value={value}
      readOnly={!editMode}
      precision={0.5}
      onChange={(event, newValue) => {
        setValue(newValue ?? 0);
      }}
    />
  );
};

export default RatingComponent;
